// export const TopNav = () => (
//   <nav className="fixed top-0 left-0 right-0 bg-gray-800 text-white h-16 flex items-center px-4 z-50">
//     <h1 className="text-xl font-semibold">Digital Twin Platform</h1>
//   </nav>
// );
import React from "react";
import { Zap, Bell, User } from "lucide-react";

export const TopNav = () => (
  <nav className="fixed top-0 left-0 right-0 bg-gradient-to-r from-slate-800 via-slate-700 to-slate-800 text-white h-16 flex items-center justify-between px-6 z-50 shadow-xl border-b border-slate-600/50">
    <div className="flex items-center gap-4">
      <div className="inline-flex items-center justify-center w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl shadow-lg">
        <Zap className="w-6 h-6 text-white" />
      </div>
      <h1 className="text-xl font-bold bg-gradient-to-r from-white to-slate-200 bg-clip-text text-transparent">
        Digital Twin Platform
      </h1>
    </div>
    
    <div className="flex items-center gap-4">
      <button className="p-2 hover:bg-white/10 rounded-xl transition-all duration-200 group">
        <Bell className="w-5 h-5 text-slate-300 group-hover:text-white transition-colors duration-200" />
      </button>
      <button className="p-2 hover:bg-white/10 rounded-xl transition-all duration-200 group">
        <User className="w-5 h-5 text-slate-300 group-hover:text-white transition-colors duration-200" />
      </button>
    </div>
  </nav>
);